var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46f8ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.586,
    x2: 29.414,
    xlinkHref: "#lg1",
    y1: 63.414,
    y2: 34.586
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.586,
    x2: 63.414,
    xlinkHref: "#lg1",
    y1: 29.414,
    y2: 0.586
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6fb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d9ae2"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.586,
    x2: 29.414,
    xlinkHref: "#lg2",
    y1: 29.414,
    y2: 0.586
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.586,
    x2: 63.414,
    xlinkHref: "#lg2",
    y1: 63.414,
    y2: 34.586
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28 34h-26c-1.105 0-2 .896-2 2v26c0 1.104.895 2 2 2h26c1.104 0 2-.896 2-2v-26c0-1.104-.896-2-2-2z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 0h-26c-1.105 0-2 .896-2 2v26c0 1.104.895 2 2 2h26c1.104 0 2-.896 2-2v-26c0-1.104-.896-2-2-2z",
    fill: "url(#SVGID_2_)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28 0h-26c-1.105 0-2 .896-2 2v26c0 1.104.895 2 2 2h26c1.104 0 2-.896 2-2v-26c0-1.104-.896-2-2-2z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 34h-26c-1.105 0-2 .896-2 2v26c0 1.104.895 2 2 2h26c1.104 0 2-.896 2-2v-26c0-1.104-.896-2-2-2z",
    fill: "url(#SVGID_4_)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.3bf691b73d9b656c9fb714e55521891e.svg";
export { ForwardRef as ReactComponent };